export default __webpack_public_path__ + "static/media/150_form_logo@2x.912d3640.png";